import React, { PureComponent } from 'react';
import { strCount, pluralHelper, replaceDashSpace } from '../../../../helpers/stringutils';
import ResponsiveImage from '../../../shared/responsiveImage';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import ButtonSpinner from '../../../shared/UI/button-spinner';
import CloseRoundSvg from '../../../shared/UI/closeRoundSvg';
import { ISOCurrencyCovert } from '../../../../helpers/locationHelper';
import { ampmConvert } from '../../../../helpers/utils';
dayjs.extend(AdvancedFormat);


class ProductCard extends PureComponent{

    constructor(props){
        super(props);
        this.state = {
            hasWarning:false
        }
        this.closeClicked = this.closeClicked.bind(this);
        this.plusClicked = this.plusClicked.bind(this);
        this.arrowClicked = this.arrowClicked.bind(this);
        this.warningCloseClicked = this.warningCloseClicked.bind(this);
    }

    componentDidMount(){
        const { builderData, id } = this.props;
        const _hasWarningMessage = (id === "itinerary-view" && builderData.message === "Product departure changed") ? true : false; 
        this.setState({hasWarning:_hasWarningMessage});
    }

    closeClicked(){
        this.props.onCloseClicked();
    }
    
    plusClicked(){
        this.props.onPlusClicked();
    }

    arrowClicked(){
        this.props.onArrowClicked();
    }

    warningCloseClicked(){
        this.setState({hasWarning:false});
    }

    render(){

        const { hasWarning } = this.state;
        const { showClose, showPlus, showArrow, index, id, builderData, itinerary, isLoading, iso_currency } = this.props;
        const currency_sign = ISOCurrencyCovert(iso_currency).props.children;
        const _name = builderData.name;
        const _duration = (id === "builder-view" || id === "itinerary-view") ? builderData.nights : builderData.duration;
        const _pricesFrom = (id === "builder-view" || id === "itinerary-view") ? "xxx" : builderData.pricesFrom;
        const _durationAndPrice = `${_duration} days from ${currency_sign}${parseFloat(_pricesFrom[0].amount).toFixed(2)}`;
        const _fromToCity = (id === "builder-view" || id === "itinerary-view") ? `${builderData.from} to ${builderData.to}` : `${builderData.startCity.name} to ${builderData.endCity.name}`;
        let _image;
        try{
            _image = (id === "builder-view" || id === "itinerary-view") ? builderData.productInfo.hero : builderData.hero;
        }catch(e){
            _image = "";
        }

        let _panelClickFunction;
        if(id === "next-destination-view") _panelClickFunction = showPlus ? this.plusClicked : null;
        if(id === "itinerary-view") _panelClickFunction = showArrow ? this.arrowClicked : null;

        return (
            <>
            <div className={`panel large-panel builder round-corners ${id} ${hasWarning ? 'hasWarning': ''}`} onClick={ hasWarning ? this.warningCloseClicked : _panelClickFunction }>
                <div className={`clearfix flex ${isLoading || hasWarning ? 'loading' : ''}`}>
                    <div className="col col-2 flex">
        
                        <ResponsiveImage width={111} widthRetina={222} src={_image} alt={""} quality={60} />
 
                    </div>
                    <div className="col col-6 pl3 flex flex-column justify-center">
                        <p className={`trip-name ${strCount(_name, 21, 'small')} margin-b-10`}>{replaceDashSpace(_name)}</p>
                        <p className="bold f-size-12">{_fromToCity}</p>
                        { id === "next-destination-view" && <p className="orange-text bold f-size-14">{_durationAndPrice}</p> }

                        {
                            (id === "builder-view" || id === "itinerary-view") && <p className="">{`${dayjs(builderData.date).format("D MMM")} - ${dayjs(builderData.endDate).format("D MMM")} `} </p>
                        }

                    </div>
                    <div className="col col-4 pr2 flex justify-end items-center">

                        {
                            (id === "itinerary-view") && (
                                <p className="right-align pr2">
                                { builderData.nights === 0 && <span className="agent-portal-grey">Accommodation <br/> not included</span> }
                                {
                                    builderData.nights !== 0 && <>
                                        <span className="green-text bold">{builderData.nights} {pluralHelper('night', builderData.nights)} </span>
                                        <span className="block agent-portal-grey">accommodation</span>
                                    </> 
                                } 
                                </p>
                            )
                        }

                        { showClose && (id === "builder-view" && index === itinerary.length - 1) &&  
                            <svg className="inline-block button close-svg" xmlns="http://www.w3.org/2000/svg" height="22.627" width="22.627" onClick={this.closeClicked}>
                                <path fill="#3D3D3D" transform="rotate(45 11.314 11.314)" fillRule="evenodd" d="M18.98 10.314h-6.666V3.647a.333.333 0 0 0-.334-.333h-1.333a.333.333 0 0 0-.333.333v6.667H3.647a.333.333 0 0 0-.333.333v1.333c0 .185.149.334.333.334h6.667v6.666c0 .185.149.334.333.334h1.333c.185 0 .334-.15.334-.334v-6.666h6.666c.185 0 .334-.15.334-.334v-1.333"/>
                            </svg>
                        }

                        { showPlus && 
                            <svg className="inline-block button plus-svg" xmlns="http://www.w3.org/2000/svg" height="16" width="16">
                                <path fill="#FF6700" fillRule="evenodd" d="M15.667 7H9V.333A.333.333 0 0 0 8.667 0H7.333A.333.333 0 0 0 7 .333V7H.333A.333.333 0 0 0 0 7.333v1.334C0 8.85.15 9 .333 9H7v6.667c0 .184.15.333.333.333h1.334c.184 0 .333-.15.333-.333V9h6.667c.184 0 .333-.15.333-.333V7.333"/>
                            </svg>
                        }

                        { showArrow && 
                            <svg className="inline-block button arrow-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="18" height="18">
                                <path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/>
                            </svg>
                        }
                    </div>
                </div>  
                {isLoading && <div className="clearfix flex loading-spinner big"><div className="col col-12 flex items-center"><ButtonSpinner /></div></div> }

                { hasWarning && 
                    <div className="panel small-panel warning-panel round-corners flex col-11 center mx-auto relative">
                        <div className="clearfix flex">
                            <div className="col col-2 flex items-center">
                                <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="warning">
                                    <path fill="currentColor" d="M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"></path>
                                </svg>
                            </div>
                            <div className="col col-10 pl3 flex flex-column left-align">
                                <p className="bold radical-text f-size-14">Trip updated</p>
                                <p className="radical-text normal">Product departure date changed.</p>
                            </div>
                        </div>
                        <div className="clearfix ReactModal__Overlay">
                            <button className="modal-close"><CloseRoundSvg /></button>
                        </div>
                    </div>
                }
            </div>
            { 
                id !== "next-destination-view" &&  
                    <p className="mt1 agent-portal-grey regular f-size-12">
                        {`Trip starts ${dayjs(builderData.date).format("D MMM")} ${ampmConvert(builderData.departure)} in ${builderData.from} and ends ${dayjs(builderData.endDate).format("D MMM")} ${ampmConvert(builderData.arrival)} in ${builderData.to}`}
                    </p>
            }
            </>
        )
    }

}

const mapStateToProps = state => {
    return{
        iso_currency:state.currentBooking.iso_currency,
        itinerary:state.currentBooking.itinerary,
        isLoading:state.cart.update_sector_loading
    }
}

export default connect(mapStateToProps, null)(ProductCard);